// domGroupDailyNamesHeader.tsx
import { CalendarGroupingEnum, CalendarSpanEnum } from "src/types";
import moment from "moment";

export const domGroupDailyNamesHeader = (
  instanceKey: string, 
  span: CalendarSpanEnum,
  grouping: CalendarGroupingEnum, 
  currentDate: Date,
  events: any[], 
  isMobile: boolean 
) => {
  let timerId: number | undefined;
  
  // Store references to modified elements for cleanup
  const modifiedElements: HTMLElement[] = [];
  const originalStyles: Map<HTMLElement, string> = new Map();

  // Store reference to cloned header for cleanup
  let clonedHeaderRef: HTMLElement | null = null;

  // Only run for group view in day span
  if(grouping !== "individual" && span === "day") {
    timerId = window.setTimeout(() => {
      const calendarContainer = document.querySelector(`#allCalendarElements2-1`);
      if (!calendarContainer) return;
      
      // Find the time view element
      const timeView = calendarContainer.querySelector('.rbc-time-view');
      if (!timeView) return;
      
      // Check if we've already processed this (to avoid duplicates)
      if (timeView.querySelector('.rbc-time-header-clone')) return;
      
      const timeHeader = calendarContainer.querySelector('.rbc-time-header') as HTMLElement;
      
      // Only proceed if time header exists
      if (timeHeader) {
        // Clone the timeHeader
        const clonedHeader = timeHeader.cloneNode(true) as HTMLElement;
        clonedHeaderRef = clonedHeader; // Store reference for cleanup
        
        // Add a class to identify the clone
        clonedHeader.classList.add('rbc-time-header-clone');

        // Hide original names from the original header (store original display values)
        const originalNameCells = timeHeader.querySelectorAll('.rbc-row.rbc-row-resource') as NodeListOf<HTMLElement>;
        originalNameCells.forEach(cell => {
          // Store original display value for cleanup
          const originalDisplay = window.getComputedStyle(cell).display;
          originalStyles.set(cell, originalDisplay);
          cell.style.display = 'none';
          modifiedElements.push(cell);
        });

        // Remove all day cells from cloned header so that we have names only
        const allDayCells = clonedHeader.querySelectorAll('.rbc-allday-cell') as NodeListOf<HTMLElement>;
        allDayCells.forEach(cell => {
          cell.style.display = 'none';
        });
        
        // Apply sticky positioning styles
        clonedHeader.style.position = 'sticky';
        clonedHeader.style.top = '0';
        clonedHeader.style.zIndex = '15';
        
        // Find the .rbc-time-view container
        const allCalendarElements = document.querySelector('.rbc-time-view');
        
        if (allCalendarElements) {
          // Insert the cloned header as the first child
          allCalendarElements.insertBefore(clonedHeader, allCalendarElements.firstChild);
        }
      }
    }, 50);
  }

  // Cleanup function
  return () => {
    // Clear the timeout if it exists
    if (timerId) {
      clearTimeout(timerId);
    }

    // Remove the cloned header using the stored reference first
    if (clonedHeaderRef && clonedHeaderRef.parentNode) {
      clonedHeaderRef.remove();
      clonedHeaderRef = null;
    }

    // Also try to remove by class name as a fallback
    const clonedHeaders = document.querySelectorAll('.rbc-time-header-clone');
    clonedHeaders.forEach(header => {
      if (header.parentNode) {
        header.remove();
      }
    });

    // Restore original styles for modified elements
    modifiedElements.forEach(element => {
      // Check if element still exists in DOM
      if (!element.parentNode) return;
      
      const originalDisplay = originalStyles.get(element);
      if (originalDisplay !== undefined) {
        element.style.display = originalDisplay;
      } else {
        // If no original style was stored, remove the display property
        element.style.removeProperty('display');
      }
    });

    // Clear the stored references
    modifiedElements.length = 0;
    originalStyles.clear();
  };
};